import React, {useEffect, useState} from "react";

const DetectDeviceResize = () => {
    const [deviceWidth, setDeviceWidth] = useState(window.innerWidth);
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 1169); 

    const handleDeviceWindowResize = () => {
        setDeviceWidth(window.innerWidth);
		setIsMobile(window.innerWidth <= 1169)
    }

    useEffect(() => {
        window.addEventListener('resize', handleDeviceWindowResize);
        return () => {
            window.removeEventListener('resize', handleDeviceWindowResize);
        }
    }, []);

    return {
		isMobile,
		deviceWidth
	}
}

export default DetectDeviceResize;